import React from 'react'
import HTag from '@/lib/HTag'

const StudentList = ({ heading, students }) => (
	<section>
		<HTag className="" {...heading} />
		StudentList
	</section>
)

export default StudentList
